<template>
  <div>
    <h2 class="text-center font-weight-light">
      Nhập thông tin từ tập tin
    </h2>
    <v-card>
      <v-card-text>
        <v-file-input
          v-model="file"
          ref="fileInput"
          label="Chọn file Excel"
          class="require"
          filled
          prepend-icon="mdi-microsoft-excel"
          autofocus
          hide-details
          messages="Lưu ý: Chỉ chấp nhận tập tin dạng: *.xls, *.xlsx"
        />
        <div 
          v-if="loading"
          class="text-center" 
        >
          <v-progress-circular
            indeterminate
            size="50"
          />
        </div>
        <v-data-table
          v-if="items.length"
          :headers="headers"
          :items="items"
          :items-per-page="5"
          class="elevation-1"
        />
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-row>
          <v-col cols="12" sm="6" md="3">
            <v-btn 
              color="cyan"
              dark
              :loading="spin"
              class="mr-2"
              @click="getTemplate"
              block
            >Lấy file mẫu</v-btn>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-btn 
              class="mr-2"
              @click="reset"
              block
            >Làm mới</v-btn>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-btn 
              class="mr-2" 
              :disabled="!file"
              @click="importData"
              block
            >Xem trước dữ liệu</v-btn>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-btn 
              :disabled="!file"
              :color="items.length ? 'success' : ''"
              @click="importData(false)"
              block
            >Import ngay</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
  import { mapActions } from 'vuex';
  import FileSevice from '@/services/File';
  export default {
    data () {
      return {
        loading: false,
        spin: false,
        errors_exist: false,
        errors: [],
        file: null,
        headers: [],
        items: []
      }
    },
    methods: {
      ...mapActions([
        'openSnackbar'
      ]),
      getTemplate(){
        const app =this;
        app.spin=true;
        axios.get(
          'api/v1/get-news-import-template',
          {responseType: 'arraybuffer'}
        )
          .then(function (response) {
            FileSevice.download(response.data, `news.xlsx`);
            app.spin=false;
            app.openSnackbar({ type: 'success' });
          })
          .catch(function (error) {
            app.openSnackbar({ type: 'error' });
            app.spin=false;
          });
      },
      reset(){
        this.file=null;
        this.items=[];
      },
      importData(preview=true) {
        const app = this;
        app.loading=true;
        const file = app.file;
        const config = {
          headers: { 'content-type': 'multipart/form-data' }
        };
        let formData = new FormData();
        formData.append('import_type', app.$route.params.type);
        formData.append('preview', preview);
        formData.append('import_file', file);
        axios.post(
          'api/v1/import-post', 
          formData, 
          config
        )
          .then(function (response) {
            app.items=[];
            if(preview) {
              app.items = response.data.datas;
              response.data.headers.forEach(function(obj, i){
                app.headers.push({ text: obj.text, value: obj.value});
              });
            }
            app.loading=false;
            app.openSnackbar({ type: 'success' });
          })
          .catch(function (error) {
            app.openSnackbar({ type: 'error' });
          });
      }
    }
  }
</script>